<template>
  <div class="group-screen">
    <div
    v-if="getCurrentGroup && !isLoading"
    class="group">
      <GroupHeader :group="getCurrentGroup" />
      <GroupStatistic :group="getCurrentGroup" />
      <GroupAnalytics :group="getCurrentGroup" />
    </div>
    <div
    v-else
    class="group-screen__not-found">
      <span class="group-screen__text">{{ getTitle }}</span>
      <TJButton
      v-if="!isLoading"
      :text="isAuthUser ? 'Перейти в каталог' : 'Перейти на главную'"
      :width="200"
      @handler="goToMain" />
    </div>
  </div>
</template>

<script>
import GroupHeader from './components/GroupHeader/GroupHeader.vue';
import GroupStatistic from './components/GroupStatistic.vue';
import GroupAnalytics from './components/GroupAnalytics/GroupAnalytics.vue';

export default {
  name: 'Group',
  components: { GroupHeader, GroupStatistic, GroupAnalytics },
  data: () => ({
    isLoading: false,
    loadError: false,
  }),
  beforeDestroy() {
    this.$store.commit('group/setCurrentGroup', null);
  },
  async created() {
    // выкидываем, если не авторизован и нет shareToken
    const shareToken = this.$route.query.shareToken || null;
    if (!this.isAuthUser && !shareToken) {
      this.$router.push({ name: 'main-landing' });
      return;
    }

    if (!this.getCurrentGroup) {
      this.isLoading = true;
      const params = { social: this.$route.params.social, id: this.$route.params.id, shareToken };

      // загружаем подборки, если пользователь авторизован (для возможности добавления канала в подборку)
      if (this.isAuthUser) {
        this.$store.dispatch('collections/getUserCompilationsList');
      }

      await this.$store.dispatch('group/getCurrentGroup', params)
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.loadError = true;
          this.isLoading = false;
          setTimeout(() => {
            this.$store.dispatch('app/setSnackBar', {
              text: 'Не удалось загрузить информацию о группе',
              error: true,
            }, 1000);
          });
        });
    }
  },
  methods: {
    goToMain() {
      this.$router.push({ name: 'main-groups' });
    },
  },
  computed: {
    getCurrentGroup() {
      return this.$store.getters['group/getCurrentGroup'];
    },
    groupNotFound() {
      return !this.isLoading && !this.getCurrentGroup;
    },
    isAuthUser() {
      const auth = this.$store.getters['auth/getUserInfo'];
      return !!auth;
    },
    getTitle() {
      if (this.loadError) {
        return 'При загрузке группы произошла ошибка. Проверьте правильность ссылки или попробуйте позже';
      }
      if (!this.getCurrentGroup && !this.isLoading) {
        return 'Нет данных о группе';
      }
      return 'Загрузка данных...';
    },
  },
};
</script>

<style lang="scss" scoped>
.group-screen {
  padding: 60px 20px 0px;
}

.group-screen__not-found {
  height: 80vh;
  width: 100%;
  max-width: 500px;
  margin: 0px auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @include between-elements {
    margin-bottom: 20px;
  }
}

.group-screen__text {
  color: $primary-gray;
  font-size: 14px;
}
</style>
